import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Empty from '../../Empty';
export default function PlaceholderColumn(_ref) {
  var dataSource = _ref.dataSource,
      columns = _ref.columns;
  var placeholderIndex; // 占位列索引

  var handleColumns = columns.map(function (column, columnIndex) {
    var placeholder = column.placeholder; // 将占位列插入到非吸附列的第一列前

    if (placeholder) {
      placeholderIndex = columnIndex;
      return {
        className: 'jmtd-table-plugin-placeholder-column',
        fillAvailable: true,
        render: function render(_t, _r, index) {
          if (index === 0) {
            return {
              children: /*#__PURE__*/React.createElement(Empty, {
                description: placeholder
              }),
              props: {
                rowSpan: dataSource.length
              }
            };
          }

          return {
            empty: true
          };
        }
      };
    }

    return column;
  });

  if (placeholderIndex != null) {
    // 添加阴影className
    [[placeholderIndex - 1, 'jmtd-table-plugin-placeholder-column-shadow-right'], [placeholderIndex + 1, 'jmtd-table-plugin-placeholder-column-shadow-left']].forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          index = _ref3[0],
          className = _ref3[1];

      var column = handleColumns[index];

      if (column) {
        handleColumns[index] = _objectSpread(_objectSpread({}, column), {}, {
          className: [className].concat(column.className || [])
        });
      }
    });
  }

  return {
    columns: handleColumns
  };
}